import React from "react";
import "./ContinueButton.scss";
import { useTranslation } from "react-i18next";

const ContinueButton = (props) => {

    const { close } = props;

    const { t } = useTranslation();

    return (
        <div className="continueButton" onClick={close}>{t('consent.continue')}</div>
    );
}

export default ContinueButton;